(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["workshop-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ch-workshop-player')) {
  customElements.define('ch-workshop-player', class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector('a');
      if (!link || this.dataset.ready) return;
      this.dataset.ready = 'true';
      link.setAttribute('role', 'button');
      link.addEventListener('keydown', (event) => {
        if (event.code === 'Space') { event.preventDefault(); link.click(); }
      });
      link.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(this.dataset.videoId) + '?autoplay=1&playsinline=1&rel=0';
        frame.title = this.dataset.title;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        this.replaceChildren(frame);
        frame.focus();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
